import { AnswerTypeEnum } from "__generated__/globalTypes";
import {
  CourseViewQueryCourse,
  CourseViewQueryCourses,
  CourseViewQueryProduct,
  CourseViewUserQueryCourse,
  CourseViewUserQueryCourses,
  CourseViewUserQueryProduct,
  CourseViewUserQueryQuestions,
  CourseViewUserQueryQuizzes,
} from "components/courses/__generated__/queries";

export type CourseIntersection = CourseViewQueryCourse & CourseViewUserQueryCourse;

export interface ProductIntersection extends CourseViewQueryProduct, CourseViewUserQueryProduct {
  courses: (CourseViewQueryCourses & CourseViewUserQueryCourses)[];
}

export type CourseQuizQuestion = CourseViewUserQueryQuestions;

export type CourseQuiz = CourseViewUserQueryQuizzes;

export type QuestionTypes = Record<string, AnswerTypeEnum>;

export const CONFIRMATION_INPUT_NAME = "confirmed";
// "Comments" question name is the GraphQL Global ID as produced by the QuizQuestion GraphQL type definition;
// it's the base64 representation of the string "quiz-question:90943"
export const COMMENTS_ESSAY_INPUT_NAME = "cXVpei1xdWVzdGlvbjo5MDk0Mw==";

export type FormValues = {
  [CONFIRMATION_INPUT_NAME]: boolean;
  [questionId: string]: string | boolean;
};
